<template>
  <div class="row">
    <div class="col-xs-12">
      <button type="button" class="btn btn-primary btn-voltar" @click="$router.back()">
        <font-awesome-icon :icon="'arrow-left'"/>
        Voltar
      </button>
      <h1 class="page-header">Adicionar Tag</h1>
      <div class="row">
        <div class="col-xs-12">
          <fieldset>
            <!-- Text input-->
            <div :class="['form-group', { 'has-error': errors.has('tag') }]">
              <label
                :class="[
                  'col-xs-12',
                  'control-label',
                  'custom-font',
                  { 'is-danger': errors.has('tag') }
                ]"
                >Nome da tag</label
              >
              <div class="col-xs-12 col-sm-6 inputGroupContainer">
                <div class="input-group">
                  <span class="input-group-addon"
                    ><font-awesome-icon
                      :icon="'id-card'"
                      :class="[{ 'is-danger': errors.has('tag') }]"
                    ></font-awesome-icon
                  ></span>
                  <input
                    ref="tag"
                    v-model="model.TAG_DCTAG"
                    name="tag"
                    v-validate="'required'"
                    maxlength="45"
                    :class="[
                      'form-control',
                      { 'is-danger': errors.has('tag') }
                    ]"
                    placeholder="Tag"
                    type="text"
                  />
                  <div
                    :class="[
                      'input-group-addon custom-input-group-addon-count',
                      { 'is-danger': errors.has('tag') }
                    ]"
                    v-text="45 - model.TAG_DCTAG.length"
                  ></div>
                </div>
                <small
                  v-if="errors.has('tag')"
                  data-bv-validator="notEmpty"
                  data-bv-validator-for="tag"
                  class="help-block"
                  style=""
                >
                  <font-awesome-icon :icon="'exclamation-triangle'" />
                  {{ errors.first('tag') }}
                </small>
              </div>
            </div>

            <!-- Button -->
            <div class="form-group">
              <div class="">
                <button
                  @click="save()"
                  class="btn btn-default"
                  :disabled="carregando"
                >
                  <font-awesome-icon v-if="carregando" :icon="'spinner'" spin />
                  <font-awesome-icon v-else :icon="'save'" />
                  Salvar
                </button>
              </div>
            </div>
          </fieldset>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.custom-font {
  font-size: 16px;
  color: #00615c;
}

.custom-input-group-addon-count {
  color: #00615c;
}

.fa-id-card {
  color: #00615c;
}

.custom-font.is-danger {
  color: #990000;
}

.custom-input-group-addon-count.is-danger {
  color: #990000;
}

.fa-id-card.is-danger {
  color: #990000;
}

.btn-voltar {
  margin-top: 20px;
}
</style>

<script>
import { request } from '@/request'

export default {
  name: 'tag-save',
  data() {
    return {
      model: {
        TAG_DCTAG: ''
      }
    }
  },
  beforeCreate() {
    if (!this.$store.state.isLogged) {
      this.$router.push('/login')
    }
  },
  mounted() {
    var params = this.$router.history.current.params
    if (params.hasOwnProperty('id')) {
      this.model.TAG_IDTAG = params.id
      this.model.TAG_DCTAG = params.name
    }
    this.$refs.tag.focus()
  },
  methods: {
    saveSuccess(result) {
      this.model.TAG_DCTAG = ''
      this.$toastr.s('Sua tag foi salva com sucesso.')
      this.$router.push('list')
    },
    saveFail(result) {
      this.$toastr.e('Houve uma falha ao tentar salvar este item.')
    },
    save() {
      this.$validator.validateAll().then(result => {
        if (!result) {
          this.$refs[this.$validator.errors.items[0].field].focus()
          this.$toastr.e(this.$validator.errors.items[0].msg)
          return
        }

        request
          .post(`tags/save`, this.model)
          .then(this.saveSuccess)
          .catch(this.saveFail)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/admin/tags/Save.vue